const earningsDrilldownNL = {
    "view": {
        "form": {
            "label": {
                "filters": "Filters",
                "monthRange": "Maandbereik",
                "startingMonth": "Beginnende Maand",
                "endingMonth": "Eindigende Maand",
                "label": "Label",
                "store": "Winkel",
                "release": "Release",
                "track": "Track",
                "country": "Land",
                "subuser": "Subgebruiker",
                "fetchingEarnings": "Inkomstenstatistieken ophalen uit database"
            },
            "button": {
                "generateReport": "Rapport Genereren",
                "resetFilters": "Filters Resetten"
            },
            "options": {
                "store": {
                    "selectStore": "Selecteer Winkel",
                    "allStores": "Alle Winkels"
                },
                "label": {
                    "selectLabel": "Selecteer Label"
                },
                "country": {
                    "allCountries": "Alle Landen"
                },
                "release": {
                    "allReleases": "Alle Releases"
                },
                "track": {
                    "allTracks": "Alle Tracks"
                },
                "subuser": {
                    "selectSubuser": "Selecteer Subgebruiker"
                },
                "period": {
                    "selectMonthRange": "Selecteer Maandbereik",
                    "last3Reports": "Laatste 3 Rapporten",
                    "last6Reports": "Laatste 6 Rapporten",
                    "last12Reports": "Laatste 12 Rapporten",
                    "custom": "Aangepast"
                }
            },
            "validation": {
                "monthRangeRequired": "* Maandbereik filter is vereist",
                "labelRequired": "* Label filter is vereist"
            }
        },
        "royaltiesSummary": {
            "title": "Royalty's Samenvatting",
            "subtitle": "Overzicht van geselecteerd Maandbereik",
            "label": {
                "monthRangeText": "Laatste 12 Verklaringen",
                "revenueEUR": "Inkomsten (€)",
                "combinedRevenue": "Gecombineerde Inkomsten",
                "combinedRevenueEUR": "Gecombineerde Inkomsten (€)",
                "otherStores": "Andere Winkels"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Winkel-specifiek Inkomstenpercentage"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Winkel-specifieke Inkomstenverdeling",
            "label": {
                "revenue": "Inkomsten"
            }
        },
        "revenueByTerritory": {
            "title": "Inkomsten Per Gebied"
        },
        "top5Releases": {
            "title": "Top 5 Releases",
            "table": {
                "column": {
                    "releaseName": "Releasenaam",
                    "revenue": "Inkomsten"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Tracks",
            "table": {
                "column": {
                    "trackName": "Tracknaam",
                    "revenue": "Inkomsten"
                }
            }
        },
        "message": {
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om gebruik te maken van deze functie.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om gebruik te maken van deze functie."
        }
    }
};

export default earningsDrilldownNL;